<div [formGroup]="form"
     class="flex-col gap-16">
    <div class="flex-col gap-8">
        <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="name">
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SET_FPS.FPS'|translate }} <span class="required">*</span></label>
        <input formControlName="fps"
               class="ui-input ui-input-40"
               type="number"
               min="1" />
    </div>
</div>